<template>
  <tr>
    <td>
      <div class="discount-row-container discount-row-container--3">
        <div
          class="discount-row-container__label"
          :class="{ 'has-text-weight-bold': estLigneSousTotal }">
          <small>{{ remise.libelle }}</small>
        </div>
      </div>
    </td>
    <td class="right">
      <small v-if="!estLigneSousTotal">{{ remise.remiseLibelle }}</small>
    </td>
    <td></td>
    <td>
      <small v-if="!estLigneSousTotal" class="has-text-right">{{ remise.type }}</small>
    </td>
    <td class="right" :class="{ 'has-background-select' : hover }">
      <div class="is-position-relative">
        <div class="is-position-relative float-right"
             :class="{ 'opacity-ligne-select' : masqueRemise
                     && !hover && isEditPrevisu }">
          <small
            class="has-text-right"
            :class="{ 'has-text-weight-bold': estLigneSousTotal }">
            {{ remise.montant }}
          </small>
        </div>
        <div v-if="(masqueRemise || hover) && isEditPrevisu"
             class="height-21px has-text-centered eyes-icon-aligement">
          <b-icon :icon="((masqueRemise && !hover) || (hover && !masqueRemise)) ? 'eye-off' : 'eye'"
                  custom-size="mdi-16px"
                  type="is-link"
                  :class="[{ 'white-round-22': hover },
                          { 'opacity-ligne-select': masqueRemise && !hover }]"
          ></b-icon>
        </div>
      </div>
    </td>
    <td></td>
    <td></td>
    <td v-if="!isPrevisualisation"></td>
  </tr>
</template>

<script>
import * as devisConf from '@/configuration/devisConf';

export default {
  props: {
    remise: {
      type: Object,
      required: true,
    },
    masqueRemise: {
      type: Boolean,
      required: true,
    },
    hover: {
      type: Boolean,
      required: true,
    },
    isEditPrevisu: {
      type: Boolean,
      required: true,
    },
    isPrevisualisation: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    estLigneSousTotal() {
      return this.remise.type
        === this.$t(this.getTypeRemiseLibelle(devisConf.TYPE_REMISE_SOUS_TOTAL));
    },
  },
  methods: {
    getTypeRemiseLibelle(type) {
      if (!type) return '';
      return devisConf.LISTE_TYPE_REMISE.find((typeRemise) => {
        return typeRemise.code === type;
      }).libelle;
    },
  },
};

</script>
